import Abstract from "../../../abstract-view/abstract.js";

export default class SortingForm extends Abstract {
  constructor(formElement) {
    super();

    this._formElement = formElement;
    this._selectElement = null;

    this._formChangeHandler = this._formChangeHandler.bind(this);
  }

  getSelectElement() {
    if (!this._selectElement) {
      this._selectElement = this._formElement.querySelector(`select`);
    }

    return this._selectElement;
  }

  getSelectValue() {
    return this.getSelectElement().value;
  }

  setSelectValue(value) {
    this.getSelectElement().value = value;
  }

  setFormChangeHandler(callback) {
    this._callback.change = callback;
    this._formElement.addEventListener(`change`, this._formChangeHandler);
  }

  _formChangeHandler() {
    this._callback.change();
  }
}
